import React from "react";
import Particles from "react-tsparticles";
import particleConfig from "../particleConfig";

export default function ParticleBackground() {
   return <Particles params={particleConfig}></Particles>;
}
